/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
require('../vendor/magnific.js');

export function popupVideo() {
  $(".playVideo").magnificPopup({
    type: 'iframe',
    iframe: {
      markup: '<div class="mfp-iframe-scaler">' +
        '<div class="mfp-close"></div>' +
        '<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
        '</div>',
      patterns: {
        youtube: {
          index: 'youtube.com/',
          id: 'v=',
          src: 'https://www.youtube.com/embed/%id%?autoplay=1&enablejsapi=1'
        }
      }
    }
  });
}
